import classNames from 'classnames';
import { Icon, FlexContainer, Txt, TxtTitle, View } from 'components';
import styles from './MessageItem.module.scss';

/**
 * MessageItem
 *
 * @return {JSX.Element}
 */
const MessageItem = ({
  className,
  subject,
  message,
  type,
  hasViewed,
  onClick,
  noWrap,
  isImage,
}) => {
  return (
    <FlexContainer
      className={classNames(
        styles.MessageItem,
        hasViewed && styles.MessageItem__viewed,
        noWrap && styles.MessageItem__noWrap,
        className,
        `${MessageItem.displayName}`
      )}
      gap
      alignCenter
      onClick={onClick}
    >
      <Icon name="message" highlight="black" />
      <FlexContainer column flex className={styles.Body}>
        <View>
          <Txt caption uppercase bold mmm>
            {type}
          </Txt>
        </View>
        <View>
          <TxtTitle bold m>
            {subject}
          </TxtTitle>
        </View>
        <View className={styles.MessageContent}>
          {isImage ? (
            <Txt italic>Image</Txt>
          ) : (
            <Txt regular caption mm>
              {message}
            </Txt>
          )}
        </View>
      </FlexContainer>
    </FlexContainer>
  );
};

MessageItem.displayName = 'MessageItem';

export default MessageItem;
